module.exports = __webpack_public_path__ + "static/media/icono_salvado_am.9abd75c2.png";